module.exports = __webpack_public_path__ + "img/sun.3c3e38a2.png";